import { Skeleton } from "@/components/ui/skeleton"

export function MembersPageSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header: icon + title + invite button */}
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-6 w-6" />
            <Skeleton className="h-9 w-32" />
          </div>
          <Skeleton className="h-5 w-64" />
        </div>
        <Skeleton className="h-9 w-40" />
      </div>

      {/* Members table */}
      <div className="rounded-md border">
        <div className="flex h-12 items-center border-b px-4">
          <Skeleton className="h-4 w-full" />
        </div>
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
            key={`skeleton-member-${i}`}
            className="flex h-16 items-center space-x-4 border-b px-4 last:border-0"
          >
            <Skeleton className="h-10 w-10 rounded-full" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-3 w-1/4" />
            </div>
            <Skeleton className="h-6 w-20 rounded-full" />
          </div>
        ))}
      </div>

      {/* Pending invites section */}
      <div className="space-y-3">
        <Skeleton className="h-7 w-44" />
        <div className="rounded-md border">
          <div className="flex h-12 items-center border-b px-4">
            <Skeleton className="h-4 w-full" />
          </div>
          {Array.from({ length: 2 }).map((_, i) => (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
              key={`skeleton-invite-${i}`}
              className="flex h-16 items-center space-x-4 border-b px-4 last:border-0"
            >
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-1/3" />
                <Skeleton className="h-3 w-1/4" />
              </div>
              <Skeleton className="h-8 w-24" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
